import { Skeleton } from "common/Skeleton/Skeleton";
import React, { CSSProperties } from "react";

interface LineSkeletonProps {
  style?: CSSProperties;
  height?: number;
  active?: boolean;
}

const LineSkeleton = ({ style, height, active = true }: LineSkeletonProps) => {
  return (
    <Skeleton
      paragraph={false}
      active={active}
      style={style}
      $height={height ?? 18}
    />
  );
};

export default LineSkeleton;
